import * as Yup from "yup";

// Validation schema for adding or editing a branch
export const BranchValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Branch name is too short")
    .required("Branch name is required"),
  branch_code: Yup.string().nullable(),
  address: Yup.string().required("Address is required"),
  phone_number: Yup.number().nullable(),
  email: Yup.string()
    .email("Invalid email")
    .required("Email is required")
    .nullable(),
  manager_name: Yup.string().nullable().min(2, "Branch name is too short"),
  manager_phone: Yup.number().nullable().min(10, "not less than ten digits"),
  opening_time: Yup.string().nullable(),
  closing_time: Yup.string().nullable(),
  working_days: Yup.array().nullable(),
  branch_preference: Yup.array(),
});
